"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Logo = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _logos = require("../shared/logos");
var _jsxRuntime = require("react/jsx-runtime");
var StyledLogo = _styledComponents.default.div.withConfig({
  displayName: "Logo__StyledLogo",
  componentId: "sc-1kvtsgt-0"
})(["display:flex;align-items:center;justify-content:center;padding:10px;svg{height:13px;width:80px;}"]);
var Logo = function Logo(_ref) {
  var logo = _ref.logo;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledLogo, {
    children: _logos.logos[logo] || _logos.logosInverted[logo]
  });
};
exports.Logo = Logo;